export const isDocumentMedia = (mediaFile: {
  isDocument?: boolean;
  url?: string;
}) => {
  return mediaFile.isDocument || mediaFile.url?.endsWith(".pdf");
};
